import React from "react";
import { t } from "i18next";
import { getMany, softDeleteById } from "services/project";
import { Util } from "common/util";
import withDataTable from "./withDataTable";
import FormInsertOrUpdate from "./FormInsertOrUpdate";

const util = new Util();
const pathName = "/donor";
const columns = [
  {
    title: t("text_donor_name"),
    dataIndex: "title",
    key: "title",
    render:(title) => {
      return <div style={{height: 35, display: 'flex',alignItems: "center"}}>
          {title}
         </div>
    }
  },
  {
    title: t("text_project_no"),
    dataIndex: "code",
    key: "code"
  },
];

const size = new URLSearchParams(document.location.search).get("size");
const current = new URLSearchParams(document.location.search).get("current");
let defaultCurrent = 1;
let defaultPageSize = 20;

if (current) {
  defaultCurrent = current;
}

if (size) {
  defaultPageSize = size;
}

const getData = () => {
  let limit = defaultPageSize;
  let current = defaultCurrent;
  let option = {};
  const params = new URLSearchParams(document.location.search);
  const searchStr = params.get("search");

  if (params.get("size")) {
    limit = params.get("size");
  }

  if (params.get("current")) {
    current = params.get("current");
  }

  option["limit"] = limit;
  option["offset"] = (current - 1) * limit;

  if (searchStr) {
    option["search"] = searchStr;
  }

  return getMany(option);
};

const handleSearch = (e) => {
  const queryParams = new URLSearchParams(document.location.search);
  const value = e.target.value;
  if (value) {
    queryParams.set("search", value);
  } else {
    queryParams.delete("search");
  }
  util.pushParamsToURL(pathName, queryParams.toString());
};

export default withDataTable({
  title: t("text_donor"),
  permission: "donor",
  showPagination: true,
  columns,
  defaultCurrent,
  defaultPageSize,
  topFilterItems: [],
  getData,
  handleSearch,
  pathName,
  FormInsertOrUpdate,
  handleAddNew: (modalRef) => modalRef.showModal(),
  handleShowUpdate: (id, modalRef) => modalRef.showModal(id),
  confirmSoftDelete: (id) => softDeleteById(id),
});
